// src/utils/csv.ts
// ----------------
// Shared CSV helpers. `escapeCsvField` moved here from
// src/services/unleashedSalesOrderCsv.ts (which re-exports it, unchanged) so the
// Reports export can use the same tested escaping. Reports fix, 5 Oct 2026: the
// Reports CSV quoted only its Status column, so a DFV Service name containing a
// comma split into extra columns (production row 2026-03121).

// RFC-4180-style field escaping: quote when the value contains a comma, quote, or
// newline, and double any internal quotes.
export function escapeCsvField(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

// UTF-8 byte-order mark. Put at the very start of a CSV file so Excel on Windows
// reads it as UTF-8 (school names contain an em dash; reasons may hold curly quotes).
// Built from its code point, not written as "﻿": the commit-time formatter
// turned that escape into an invisible literal character, which is easy to lose.
export const CSV_BOM = String.fromCharCode(0xfeff);

// Turn a table (header row + data rows) into CSV text. Every cell is escaped;
// null/undefined become an empty cell; numbers are stringified as-is.
export function toCsv(table: unknown[][], lineEnd = "\n"): string {
  return table
    .map((row) => row.map((cell) => escapeCsvField(cell == null ? "" : String(cell))).join(","))
    .join(lineEnd);
}

// Download a table as a CSV file in the browser: BOM + toCsv, UTF-8 labelled.
// The one download path for the Reports exports.
export function downloadCsv(table: unknown[][], filename: string): void {
  const blob = new Blob([CSV_BOM + toCsv(table)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
